import React, {useState} from 'react';
import TaskSelector from '../components/attendance/TaskSelector.js';
import Box from '../components/ui/Box.js';

const AttendancePage = (props) => {
	
	// const [task, setTask] = useState(false);
	const [task, setTask] = useState({
		'TaskID': 1,
		'data': {
			'rows': [4113, 4114, 4116],
			'plants': 500
		}
	});
	
	const onTaskChange = (e) => {
		console.log("Updating task state", e);
		setTask(e);
	}
	
	
	return <div>
		<h2>Task test</h2>
		<Box>
			<TaskSelector date={new Date()} field={90} onChange={onTaskChange} task={task} />
		</Box>
	</div>;
}
export default AttendancePage;